import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import { ContractDuration } from "../../file.interface";

const years: ContractDuration[] = Object.values(ContractDuration);

const DurationScreen2: React.FC = () => {
  const { selectedIndustry, selectedContractDuration, dispatch } =
    useAppContext();
  const navigate = useNavigate();

  const handleYear = (year: ContractDuration): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedContractDuration: year },
    });
  };

  const handleNavigation = () => {
    navigate("/sites-screen-3");
  };

  return (
    <div className="screen-container">
      <h3 className="title-screen">Choose your contract length</h3>

      {selectedIndustry && (
        <>
          <h4 className="subtitle-screen">
            This will help us give you a more accurate estimate.
          </h4>

          <div className="menu-conf-container">
            {years.map((year, i) => (
              <div
                key={i}
                className={`${
                  selectedContractDuration === year
                    ? "card-menu-conf-selected"
                    : ""
                } card-menu-conf`}
                onClick={() => handleYear(year)}
              >
                <div className="menu-conf-title">{year}</div>
                <div className="menu-conf-price"></div>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
        {selectedContractDuration && (
          <button
            className="app-button next-button"
            onClick={() => handleNavigation()}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default DurationScreen2;
